import React from 'react';
import styled, { css } from 'styled-components';

import CopyableValue from 'src/presentation/components/pages/email/components/CopyableValue';
import TableLayout from 'src/presentation/components/layouts/table/TableLayout';
import TableList from 'src/presentation/components/pages/shared/TableList';
import { StyledTR, StyledTD } from 'src/presentation/components/pages/shared/Table';

const COLUMN_CONFIG = [
  {
    attr: 'authType',
    label: 'Name',
    customColumnStyle: () => ({ width: '30px', textAlign: 'left' }),
    customStyle: () => ({ textAlign: 'left' }),
  },
  {
    attr: 'recordType',
    label: 'Type',
    customColumnStyle: () => ({ width: '30px', textAlign: 'left' }),
    customStyle: () => ({ textAlign: 'left' }),
  },
  {
    attr: 'name',
    label: 'Hostname',
    customColumnStyle: () => ({ width: '240px', textAlign: 'left' }),
    customStyle: () => ({ textAlign: 'left' }),
  },
  // @ts-ignore
  { attr: 'value', label: 'Value', customRenderer: ({ value }) => <CopyableValue value={value} /> },
];

const dataAidPrefix = 'email-domains-editor';

const DnsRecordsTable = ({ dnsRecords, isLoading }): JSX.Element => {
  return (
    <StyledTableList
      columnConfig={COLUMN_CONFIG}
      dataAid={`${dataAidPrefix}-table`}
      isLoading={isLoading}
      items={dnsRecords}
      pageName=""
      renderRowActions={() => null}
    />
  );
};

const hideTableHeader = ({ dataAid }) => css`
  [data-aid='${dataAid}'] {
    & > div:nth-child(1) {
      display: none;
    }
  }
`;

const StyledTableList = styled(TableList)`
  margin-bottom: 24px;

  ${p => hideTableHeader(p)}

  ${TableLayout} {
    margin: 0;
    border-radius: 0;
    height: ${p => (p.isLoading ? '250px' : 'fit-content')};
  }

  ${StyledTR}:hover {
    &:nth-child(odd) {
      background-color: transparent;
    }
    &:nth-child(even) {
      background-color: ${p => p.theme.colors.gray100};
    }
  }

  ${StyledTD} {
    text-overflow: none;
    white-space: normal;
    word-break: break-all;
  }
`;

export default DnsRecordsTable;
